import React from "react";
import { Modal } from "antd";
import PDFFieldMapper from "./PDFFieldMapper";

/**
 * A modal component that wraps the PDFFieldMapper component for configuring field mappings on PDF documents
 *
 * @component
 * @param {Object} props - Component properties
 * @param {boolean} props.visible - Controls the visibility of the modal
 * @param {Function} props.onCancel - Callback function triggered when the modal is closed or cancelled
 * @param {Function} props.onSave - Callback function triggered when the field mapping configuration is saved
 *                                 Receives the configuration object as a parameter
 * @param {Object} [props.initialConfig=null] - Initial field mapping configuration to populate the mapper
 * @param {string} [props.base64Content=null] - Base64 encoded PDF content to be displayed in the mapper
 * @param {string} [props.title="PDF Field Configuration"] - Title text displayed in the modal header
 * @returns {React.ReactElement} A modal containing the PDF field mapping interface
 *
 * @example
 * <PDFFieldMapperModal
 *   visible={showModal}
 *   onCancel={() => setShowModal(false)}
 *   onSave={(config) => handleSaveConfig(config)}
 *   initialConfig={existingConfig}
 *   base64Content={pdfContent}
 *   title="Configure Form Fields"
 * />
 */
const PDFFieldMapperModal = ({
  visible,
  onCancel,
  onSave,
  initialConfig = null,
  base64Content = null,
  title = "PDF Field Configuration",
}) => {
  return (
    <Modal
      title={title}
      open={visible}
      onCancel={onCancel}
      width={1200}
      footer={null}
      destroyOnClose={true}
    >
      <PDFFieldMapper
        standalone={false}
        onSave={(config) => {
          if (onSave) {
            onSave(config);
          }
          onCancel();
        }}
        initialConfig={initialConfig}
        base64Content={base64Content}
        isFormContext={false}
      />
    </Modal>
  );
};

export default PDFFieldMapperModal;
